import React from "react";
import { fmtMonthRange } from "../utils";

export function Header({ year, month, onPrevMonth, onNextMonth, onToday, isCurrent }) {
  const mk = `${year}-M${String(month).padStart(2, "0")}`;

  return (
    <div className="hero">
      <div className="header-brand">
        <svg className="header-logo-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 3v17" />
          <path d="M9 20h6" />
          <path d="M5 7h14" />
          <path d="M5 7L2 13h6L5 7" />
          <path d="M19 7L16 13h6L19 7" />
        </svg>
        <div>
          <h1>Registro Mensual de Actividades</h1>
          <p className="subtitle">DGIT · Consejo de la Magistratura de CABA</p>
        </div>
      </div>
      <div className="header-actions">
        <button onClick={onPrevMonth} className="btn-info" title="Mes anterior">
          <i className="ti ti-chevron-left"></i> Anterior
        </button>
        <div className="header-meta">
          <span>{mk}</span>
          <span>{fmtMonthRange(year, month)}</span>
        </div>
        <button onClick={onNextMonth} className="btn-info" title="Siguiente mes">
          Siguiente <i className="ti ti-chevron-right"></i>
        </button>
        {!isCurrent && (
          <button onClick={onToday} className="btn-primary">
            Hoy
          </button>
        )}
      </div>
    </div>
  );
}
